export * from "react-native-bootsplash";
export { default } from "react-native-bootsplash";
